<template>
  <div>
    <div v-if="options.showTitle">
      <span class="cs-title">{{!!this.workflowService.Id ? this.workflowService.ServiceName : "真留服务明细"}}</span>
    </div>
    <el-row v-if="options.showTitle">
      <el-col>&nbsp;</el-col>
    </el-row>
    <div v-if="!showError && !!this.workflowService.Id">
      <table>
        <tr>
          <td>
            <span>报名日期:</span>
          </td>
          <td>
            <span>{{$moment(workflowService.CreateTime).format("YYYY/MM/DD")}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>价值总额:</span>
          </td>
          <td>
            <span>{{workflowService.SaleAmountDiscounted|toCurrency(workflowService.WorkflowCurrency)}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <span>剩余总额:</span>
          </td>
          <td>
            <span>{{workflowService.SaleAmountAvailable|toCurrency(workflowService.WorkflowCurrency)}}</span>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <el-row>
        <el-col>
          <span class="cs-color-frenchgrey" v-text="errorMessage"></span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getSAStudentWorkflowService } from "@/service/studyAbroad.service";

const defaultWorkflowService = {
  Id: 0,
  WorkflowId: 0,
  ServiceId: 0,
  ServiceName: null,
  StartDate: null,
  StartDateText: null,
  ContractId: null,
  ContractName: null,
  Discount: 0,
  DiscountPercentage: 0,
  DiscountAmount: 0,
  CashDecreasedAmount: 0,
  Comment: null,
  ServiceItemList: [],
  WorkflowCurrency: 1,
  CreateTime: null,
  SaleAmountDiscounted: 0,
  SaleAmountAvailable: 0,
};

export default {
  name: "workflowServiceInfo",
  props: {
    options: {
      showTitle: {
        type: Boolean,
        default: false,
      },
    },
    dataIn: {
      workflowServiceId: {
        type: [Number, String],
        default: 0,
      },
      workflowServiceData: {
        type: Object,
        default: () => {
          return null;
        },
      },
    },
  },
  data() {
    return {
      showError: false,
      errorMessage: "未查询到该服务",
      workflowService: Object.clone(defaultWorkflowService),
    };
  },
  created() {
    this.reloadWorkflowService();
  },
  methods: {
    async loadSAWServiceFromServer() {
      if (!this.dataIn.workflowServiceId) {
        this.showError = true;
        return;
      }

      let result = await getSAStudentWorkflowService(
        this.dataIn.workflowServiceId
      );
      this.workflowService =
        !!result && result.success
          ? result.data
          : Object.clone(defaultWorkflowService);
      this.showError = !this.workflowService.Id;
    },
    reloadWorkflowService() {
      if (
        !!this.dataIn.workflowServiceData &&
        !!this.dataIn.workflowServiceData.Id
      ) {
        this.workflowService = Object.clone(this.dataIn.workflowServiceData);
        this.showError = false;
        return;
      }

      this.loadSAWServiceFromServer();
    },
  },
  watch: {
    dataIn(newValue) {
      this.reloadWorkflowService();
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  padding-right: 10px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflowServiceInfo.vue